<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <!-- <h4 class="text-themecolor">Questionnaire</h4> -->
            <h4 class="text-themecolor">{{ myTitle }}</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">{{ myTitle }}</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4">
            <div class="text-right">
              <button
                class="btn btn-success waves-effect mt-2 mb-2"
                type="button"
                name="aQDemo"
                @click="addNewClick"
              >
                <i class="fas fa-plus fa-2x"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <!-- table responsive -->
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <div
            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
          >
            <div class="dataTables_length">
              <span style="margin-right: 10px"
                ><label for="">Show </label>
              </span>
              <select
                v-model="pageSize"
                class="form-control form-control-sm"
                aria-label="Default select example"
                @change="pageChange(1)"
              >
                <option selected>50</option>
                <option value="100">100</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
                <option value="2000">2000</option>
              </select>

              <span style="margin-left: 10px">
                <label for=""> Entries </label></span
              >
            </div>
            <div class="dataTables_filter">
              <span class="float-right">
                <span style="margin-right: 10px"
                  ><label for="Search">Search:</label></span
                >
                <input type="text" @change="SearchDataTable()" v-model="filter" name="" id="" />
              </span>
            </div>
          </div>
                  <!-- *******************************************************************************  -->
                  <table
                    class="
                      table
                      display
                      table-bordered
                      text-center
                      table-striped
                      no-wrap
                    "
                    id="table001"
                  >
                    <thead class="thead-dark">
                      <tr>
                        <th>Action</th>
                        <th>Status <span style="float-rigth"> <button class="asc-desc-btn" @click="orderBy(1)" style="float:right">&uarr; &darr;</button> </span></th>
                        <th>{{ myTitle }} ID <span style="float-rigth"> <button class="asc-desc-btn" @click="orderBy(2)" style="float:right">&uarr; &darr;</button> </span></th>
                        <th>Question Name <span style="float-rigth"> <button class="asc-desc-btn" @click="orderBy(3)" style="float:right">&uarr; &darr;</button> </span></th>
                        <th>Question Type <span style="float-rigth"> <button class="asc-desc-btn" @click="orderBy(4)" style="float:right">&uarr; &darr;</button> </span></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(q, index99) in quesList" :key="q.questId">
                        <td class="text-center">
                          <div class="btn-group">
                            <button
                              type="button"
                              class="btn btn-success"
                              data-toggle="modal"
                              :disabled="demo.updButton == 0 || getChanges(q)"
                              data-target="#TextBox"
                              @click="editButtonClick(q.questId)"
                            >
                              Edit
                            </button>
                            <button
                              type="button"
                              class="
                                btn btn-success
                                dropdown-toggle dropdown-toggle-split
                              "
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              :disabled="demo.delButton == 0  || getChanges(q)"
                            >
                              <span class="sr-only">Toggle Dropdown</span>
                            </button>
                            <div class="dropdown-menu animated flipInY">
                              <a
                                v-if="q.isActive == true"
                                class="dropdown-item"
                                href="javascript:void(0)"
                                data-toggle="modal"
                                data-target=""
                                @click="archiveClick(q.questId, index99)"
                                >Archive</a
                              >
                               <a v-else
                                class="dropdown-item"
                                href="javascript:void(0)"
                                data-toggle="modal"
                                data-target=""
                                @click="activeClick(q.questId, index99)"
                                >Activate</a
                              >
                            </div>
                          </div>
                        </td>
                        <td>
                          <span
                            class="bs-label label-success badgeBorder"
                            v-if="q.isActive"
                            >Active
                          </span>
                          <span class="bs-label label-danger badgeBorder" v-else
                            >Archive</span
                          >
                        </td>
                        <!-- <td>
                          <div class="col-lg-3 switchery-demo">
                            <label class="switch text-center">
                              <input
                                class=""
                                type="checkbox"
                                v-model="q.isRequired"
                                @change="
                                  DemoActiveChange(q.questId, q.isRequired)
                                "
                                :disabled="updButton == 0  || getChanges(q)"
                              />
                              <span class="slider round"></span>
                            </label>
                          </div>
                        </td> -->
                        <td v-if="myTitle == 'Demo'">DID-{{ q.questIdSerial }}</td>
                        <td v-else>QID-{{ q.questIdSerial }}</td>
                        <!-- <td>{{ q.questName }}</td> -->
                        <td>{{ q.question }}</td>
                        <td>{{ q.questionInputTypeName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <nav aria-label="Page navigation" >
              <div style="float:left">
                <span v-if="totalRows < pageSize * pageNumber ">showing {{totalRows}} of {{totalRows}} records</span>
                <span v-else>showing {{pageSize * pageNumber }} of {{totalRows}} records</span>
                </div>
            <ul class="pagination" style="float:right;">
              <li class="page-item colorActive">
                <span v-if="pageNumber==1">
                  <button disabled class="page-link disabledColor"  @click="pageChange('Previous')"
                  >Previous</button
                >
                 </span>
                <span v-else>
                <button class="page-link " @click="pageChange('Previous')"
                  >Previous</button
                >
                </span>
               
              </li>

              <li v-for="pageNum in totalPages" :key="pageNum" class="page-item colorActive">
                <span v-if="pageNumber==pageNum"><button class="page-link activeColor" disabled  @click="pageChange(pageNum)">{{pageNum}} </button> </span>
                <span v-else> <button class="page-link" @click="pageChange(pageNum)">{{pageNum}} </button></span>
              </li>
             
              <li class="page-item colorActive">
                <span v-if="pageNumber==totalPages">
                 <button disabled class="page-link disabledColor" @click="pageChange('Next')">Next</button>
                </span>
                <span v-else>
                <button class="page-link" @click="pageChange('Next')">Next</button>
                </span>
              </li>
            </ul>
          </nav>
              </div>
            </div>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->

    <!-- demo Modal -->
    <div
      class="modal fade"
      id="demoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal modal-lg">
        <div class="modal-content" style="width: 130% !important">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">
              Add {{ myTitle }}
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <!-- Header -->

          <!-- Body -->
          <div class="modal-body">
            <form>
              <!-- select -->
              <div class="col-xl-12">
                <fieldset class="fieldset-border">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <h4 class="font-weight-bold">Choose Answer Type</h4>
                      <div class="">
                        <button
                          id="btn-active"
                          type="button"
                          class="btn btn-outline-info myActive"
                          @click="showQuestionTypeTextbox()"
                        >
                          Textbox
                        </button>
                        <button
                          id="btn_active"
                          type="button"
                          class="btn btn-outline-info myActive"
                          @click="showQuestionTypeCheckbox()"
                        >
                          Checkbox
                        </button>
                        <button
                          id="active-btn"
                          type="button"
                          class="btn btn-outline-info myActive"
                          @click="showQuestionTypeRating()"
                        >
                          Rating
                        </button>
                        <button
                          id="active_btn"
                          type="button"
                          class="btn btn-outline-info myActive"
                          @click="showQuestionTypeRadio()"
                        >
                          Radio Button
                        </button>
                        <button
                          id="active-bt"
                          type="button"
                          class="btn btn-outline-info myActive"
                          @click="showQuestionTypeEmail()"
                        >
                          Email
                        </button>
                        <button
                          id="active-bn"
                          type="button"
                          class="btn btn-outline-info myActive"
                          @click="showQuestionTypePhone()"
                        >
                          Phone Number
                        </button>
                        <button
                          id="active-n"
                          type="button"
                          class="btn btn-outline-info myActive"
                          @click="showQuestionTypeDate()"
                        >
                          Date
                        </button>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <!-- select -->

              <!-- Textbox -->
              <div class="col-xl-12 question_type" id="question_type_textbox">
                
                  <h4 class="font-weight-bold h3Spacing">Textbox</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                  <div
                    class="form-group m-b-40"
                    style="display: none"
                    v-bind:class="[quest.answer.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      v-model="quest.answer"
                    /><span class="bar"></span>
                    <label for="">Please Type Your Answer:</label>
                  </span>
                  </div>
                
              </div>
              <!-- Textbox -->

              <!-- Checkbox -->
              <div class="col-xl-12 question_type" id="question_type_checkbox">
                
                  <h4 class="font-weight-bold h3Spacing">Checkbox</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                
                <div id="checkboxDynamic"></div>
                <div class="input-group">
                  <ul class="ul1">
                    <div
                      class="row"
                      v-for="(qq, index1) in checkOpt"
                      :key="index1"
                    >
                      <div class="floating-labels row">
                        <div class="form-group m-b-40">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id=""
                            maxlength="30"
                            placeholder="Option"
                            v-model="qq.questOption"
                          />
                          <span class="bar"></span>
                        </div>
                      </div>
                      <li v-if="index1 == checkOpt.length - 1">
                        <button
                          class="btn btn-success m-l-20"
                          type="button"
                          @click="checkboxDynamic('+', 99)"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </li>
                      <li v-else>
                        <button
                          class="btn btn-danger m-l-20"
                          type="button"
                          @click="checkboxDynamic('-', index1)"
                        >
                          <i class="fa fa-minus"></i>
                        </button>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
              <!-- Checkbox -->

              <!-- Rating -->
              <div class="col-xl-12 question_type" id="question_type_rating">
                
                  <h4 class="font-weight-bold h3Spacing">Rating</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                
                <div class="form-group" id="">
                  <div class="col-sm-6">
                    <div class="col-l-12">
                      <div class="input-group" style="width: 200% !important">
                        <ul class="ul1">
                          
                            <div
                              class="row"
                              v-for="(rt, ndx) in rating"
                              :key="ndx"
                            >
                              <div class="form-group col-2 m-r-20">
                                <InputText
                                  class="form-control float-class"
                                  type="radio"
                                  value="1"
                                  name="radio"
                                  :id="'radio1-' + ndx"
                                />
                                <label
                                  for="radio1"
                                  class="btn btn-outline-info label1"
                                  >O{{ ndx + 1 }}</label
                                >
                              </div>
                              <div class="form-group col-8">
                                <InputText
                                  type="text"
                                  class="form-control float-class"
                                  id=""
                                  maxlength="30"
                                  placeholder="Option"
                                  v-model="rt.head"
                                /><span class="bar"></span>
                              </div>
                            </div>
                        
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Rating -->

              <!-- Radio -->
              <div class="col-xl-12 question_type" id="question_type_radio">
                
                  <h4 class="font-weight-bold h3Spacing">Radio</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                
                <div id="radioDynamic"></div>
                <div
                  class="row"
                  v-for="(qqq, index2) in checkOpt"
                  :key="index2"
                >
                  <ul class="ul1">
                    <div class="row">
                      <div class="floating-labels row">
                        <div class="form-group m-b-40">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id=""
                            maxlength="30"
                            placeholder="Option"
                            v-model="qqq.questOption"
                          />
                          <span class="bar"></span>
                        </div>
                      </div>
                      <li v-if="index2 == checkOpt.length - 1">
                        <button
                          class="btn btn-success m-l-20"
                          type="button"
                          @click="checkboxDynamic('+', 99)"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </li>
                      <li v-else>
                        <button
                          class="btn btn-danger m-l-20"
                          type="button"
                          @click="checkboxDynamic('-', index2)"
                        >
                          <i class="fa fa-minus"></i>
                        </button>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
              <!-- Radio -->

              <!-- Email*122-->
              <div class="col-xl-12 question_type" id="question_type_email">
                
                  <h4 class="font-weight-bold h3Spacing">Email</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                  <!-- <div
                    class="form-group m-b-40"
                    style="display: none"
                    v-bind:class="[quest.answer.length > 0 ? 'focused' : '']"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id=""
                      maxlength="40"
                      v-model="quest.answer"
                    /><span class="bar"></span>
                    <label for="">Email Address</label>
                  </div> -->
                
              </div>
              <!-- Email -->

              <!-- Phone -->
              <div class="col-xl-12 question_type" id="question_type_phone">
                
                  <h4 class="font-weight-bold h3Spacing">Phone Number</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                  <div
                    class="form-group m-b-40"
                    style="display: none"
                    v-bind:class="[quest.answer.length > 0 ? 'focused' : '']"
                  >
                    <InputText
                      v-if="optionSelected == 6"
                      v-mask="'###-###-####'"
                      type="tel"
                      class="form-control float-class"
                      id=""
                      v-model="quest.answer"
                    />
                    <span class="bar"></span>
                    <label for="">Phone Number</label>
                  </div>
                
              </div>
              <!-- Phone -->

              <!-- Date -->
              <div class="col-xl-12 question_type" id="question_type_date">
                
                  <h4 class="font-weight-bold h3Spacing">Date</h4>
                  <div
                    class="form-group"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      style="margin-left: 10px"
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                  <div class="form-group m-b-40" style="display: none">
                    <InputText type="date" class="form-control float-class" id="NewDate" /><span
                      class="bar"
                    ></span>
                  </div>
                
              </div>
              <!-- Date -->

              <button
                class="btn btn-outline-success waves-effect col-12"
                type="button"
                @click="saveClick"
                id="Demosave_btn"
              >
                Save
              </button>
            </form>
          </div>
          <!--body -->
        </div>
      </div>
    </div>
    <!-- demo Modal -->

    <!---------------------------------------------------- **EDITS** -->
    <!-- TextBoxEdit -->
    <div
      class="modal fade"
      id="TextBoxEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Edit</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <!-- Header -->

          <!-- Body -->
          <div class="modal-body">
            <form>
              <!-- Textbox -->
              <div class="col-xl-12">
                
                  <h4 class="font-weight-bold h3Spacing">Textbox</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                  <!-- <div class="form-group m-b-40"
                    v-bind:class="[
                              quest.answer.length > 0 ? 'focused' : '',
                            ]">
                    <input
                      type="text"
                      class="form-control"
                      id=""
                      v-model="quest.answer"
                    /><span class="bar"></span>
                    <label for="">Please Type Your Answer:</label>
                  </div> -->
                
              </div>
              <!-- Textbox -->

              <button
                class="btn btn-outline-success waves-effect col-12"
                @click="updateClick"
                id="Upd_btn"
              >
                Update
              </button>
            </form>
          </div>
          <!--body -->
        </div>
      </div>
    </div>
    <!-- TextBoxEdit -->

    <!-- CheckBoxEdit -->
    <div
      class="modal fade"
      id="CheckBoxEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Edit</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <!-- Header -->

          <!-- Body -->
          <div class="modal-body">
            <form>
              <!-- Checkbox -->
              <div class="col-xl-12">
                
                  <h4 class="font-weight-bold h3Spacing">Checkbox</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                
                <div id="checkboxDynamicV2"></div>
                <div class="input-group">
                  <ul class="ul1">
                    <div
                      class="row"
                      v-for="(qq, index1) in checkOpt"
                      :key="index1"
                    >
                      <div class="floating-labels row">
                        <div class="form-group m-b-40">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id=""
                            maxlength="50"
                            placeholder="Option"
                            v-model="qq.questOption"
                          />
                          <span class="bar"></span>
                        </div>
                      </div>
                      <li v-if="index1 == checkOpt.length - 1">
                        <button
                          class="btn btn-success m-l-20"
                          type="button"
                          @click="checkboxDynamic('+', 99)"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </li>
                      <li v-else>
                        <button
                          class="btn btn-danger m-l-20"
                          type="button"
                          @click="checkboxDynamic('-', index1)"
                        >
                          <i class="fa fa-minus"></i>
                        </button>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
              <!-- Checkbox -->

              <button
                class="btn btn-outline-success waves-effect col-12"
                @click="updateClick"
                id="Upd_btn"
              >
                Update
              </button>
            </form>
          </div>
          <!--body -->
        </div>
      </div>
    </div>
    <!-- CheckBoxEdit -->

    <!-- Rating -->
    <div
      class="modal fade"
      id="RatingEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Edit</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <!-- Header -->

          <!-- Body -->
          <div class="modal-body">
            <form>
              <!-- Rating -->
              <div class="col-xl-12">
                
                  <h4 class="font-weight-bold h3Spacing">Rating</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                
                <div class="form-group" id="">
                  <div class="col-sm-6">
                    <div class="col-xl-12">
                      <div class="input-group" style="width: 200% !important">
                        <ul class="ul1">
                          <fieldset class="floating-labels">
                            <div
                              class="row"
                              v-for="(co, ndx2) in checkOpt"
                              :key="ndx2"
                            >
                              <div class="form-group col-2 m-r-20">
                                <InputText
                                  class="input1"
                                  type="radio"
                                  value="1"
                                  name="radio"
                                  :id="'radio1-' + ndx2"
                                />
                                <label
                                  for="radio1"
                                  class="btn btn-outline-info label1"
                                  >O{{ ndx2 + 1 }}</label
                                >
                              </div>
                              <div
                                class="form-group col-8"
                                v-bind:class="[
                                  co.questOption.length > 0 ? 'focused' : '',
                                ]"
                              >
                                <InputText
                                  type="text"
                                  class="form-control float-class"
                                  id=""
                                  maxlength="50"
                                  v-model="co.questOption"
                                  placeholder="Option"
                                /><span class="bar"></span>
                              </div>
                            </div>
                          </fieldset>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Rating -->

              <button
                class="btn btn-outline-success waves-effect col-12"
                @click="updateClick"
                id="Upd_btn"
              >
                Update
              </button>
            </form>
          </div>
          <!--body -->
        </div>
      </div>
    </div>
    <!-- RatingEdit -->

    <!-- RadioEdit -->
    <div
      class="modal fade"
      id="RadioEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Edit</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <!-- Header -->

          <!-- Body -->
          <div class="modal-body">
            <form>
              <!-- Radio -->
              <div class="col-xl-12">
                
                  <h4 class="font-weight-bold h3Spacing">Radio</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                  <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                

                <div id="radioDynamicV2"></div>
                <div class="input-group">
                  <ul class="ul1">
                    <div
                      class="row"
                      v-for="(qq, index1) in checkOpt"
                      :key="index1"
                    >
                      <div class="floating-labels row">
                        <div class="form-group m-b-40">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id=""
                            maxlength="50"
                            placeholder="Option"
                            v-model="qq.questOption"
                          />
                          <span class="bar"></span>
                        </div>
                      </div>
                      <li v-if="index1 == checkOpt.length - 1">
                        <button
                          class="btn btn-success m-l-20"
                          type="button"
                          @click="checkboxDynamic('+', 99)"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </li>
                      <li v-else>
                        <button
                          class="btn btn-danger m-l-20"
                          type="button"
                          @click="checkboxDynamic('-', index1)"
                        >
                          <i class="fa fa-minus"></i>
                        </button>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
              <!-- Radio -->
              <button
                class="btn btn-outline-success waves-effect col-12"
                @click="updateClick"
                id="Upd_btn"
              >
                Update
              </button>
            </form>
          </div>
          <!--body -->
        </div>
      </div>
    </div>
    <!-- RadioEdit -->

    <!-- EmailEdit -->
    <div
      class="modal fade"
      id="EmailEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Edit</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <!-- Header -->

          <!-- Body -->
          <div class="modal-body">
            <form>
              <!-- Email -->
              <div class="col-xl-12">
                
                  <h4 class="font-weight-bold h3Spacing">Email</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                    <span class="p-float-label">
                    <InputText
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                    </span>
                  </div>
                  <!-- <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.answer.length > 0 ? 'focused' : '']"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id=""
                      maxlength="40"
                      v-model="quest.answer"
                    /><span class="bar"></span>
                    <label for="">Email Address</label>
                  </div> -->
                
              </div>
              <!-- Email -->
              <button
                class="btn btn-outline-success waves-effect col-12"
                @click="updateClick"
                id="Upd_btn"
              >
                Update
              </button>
            </form>
          </div>
          <!--body -->
        </div>
      </div>
    </div>
    <!-- EmailEdit -->

    <!-- phoneQ -->
    <div
      class="modal fade"
      id="PhoneQ"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Edit</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <!-- Header -->

          <!-- Body -->
          <div class="modal-body">
            <form>
              <!-- Email -->
              <div class="col-xl-12">
                
                  <h4 class="font-weight-bold h3Spacing">Phone</h4>
                  <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                    <span class="p-float-label">
                    <InputText
                      style="margin-top: 10px"
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                    </span>
                  </div>
                  <!-- <div
                    class="form-group m-b-40"
                    v-bind:class="[quest.answer.length > 0 ? 'focused' : '']"
                  >
                    <input
                      v-mask="'###-###-####'"
                      type="tel"
                      class="form-control"
                      id=""
                      v-model="phoneDummy"
                    /><span class="bar"></span>
                    <label for="">Phone Number</label>
                  </div> -->
                
              </div>
              <!-- Email -->
              <button
                class="btn btn-outline-success waves-effect col-12"
                @click="updateClick"
                id="Upd_btn"
              >
                Update
              </button>
            </form>
          </div>
          <!--body -->
        </div>
      </div>
    </div>
    <!-- phoneQ -->

    <!-- DOBQ -->
    <div
      class="modal fade"
      id="DOBQ"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog cascading-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Edit</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <!-- Header -->

          <!-- Body -->
          <div class="modal-body">
            <form>
              <!-- Date -->
              <div class="col-xl-12">
                
                  <h4 class="font-weight-bold h3Spacing">Date</h4>
                  <div
                    class="form-group"
                    v-bind:class="[quest.question.length > 0 ? 'focused' : '']"
                  >
                    <span class="p-float-label">
                    <InputText
                      style="margin-top: 10px"
                      type="text"
                      class="form-control float-class"
                      id=""
                      maxlength="150"
                      v-model="quest.question"
                    /><span class="bar"></span>
                    <label for="">Question<span  style="color:red"> *</span></label>
                    </span>
                  </div>
                  <!-- <div class="form-group m-b-40">
                    <input
                      type="date"
                      class="form-control"
                      id="EditDate"
                    /><span class="bar"></span>
                  </div> -->
                
              </div>
              <!-- Date -->
              <button
                class="btn btn-outline-success waves-effect col-12"
                @click="updateClick"
                id="Upd_btn"
              >
                Update
              </button>
            </form>
          </div>
          <!--body -->
        </div>
      </div>
    </div>
    <!-- DOBQ -->
  </div>
</template>

<script>
import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import Swal from "sweetalert2";

export default {
  name: "Physicians",

  data() {
    return {
      EmployeeRolesStr: [],
      demo: {
        updButton: 1,
        delButton: 1,
      },
      //loader
      loader: "",
      //Timer
      
      TimerObject: {},
      quesList: [],
      phoneDummy: "",
      quest: {
        question: "",
        answer: "",
        questionInputTypeId: 0,
      },
      checkOpt: [{ questOption: "" }],
      rating: [
        { head: " " },
        { head: " " },
        { head: " " },
        { head: " " },
        { head: " " },
      ],

      optionSelected: 0,
      ckeckboxCount: 1,

      myTitle: "Demo",
      //dataTable options
      pageSize: 50,
      pageNumber: 1,
      totalPages: 0,
      filter: "",
      totalRows: 0,

    };
  }, // end data()

  methods: {
    getChanges(q){
      debugger;
      if(q.questId<20)
      {
        return true;
      }
      else{
        return false;
      }
    // if(q.question == 'First Name' || q.question == 'LastName' || q.question == 'DOB' || q.question == 'Gender'
    //    || q.question == 'ExternalId' || q.question == 'SSN' || q.question == 'Phone' 
    //    || q.question == 'Email' || q.question == 'Street' || q.question == 'City' 
    //    || q.question == 'State' || q.question == 'Zip' || q.question == 'Primary Insurance Name' 
    //    || q.question == 'Primary Insurance Number' || q.question == 'Primary Insurance Group Name' 
    //    || q.question == 'Primary Insurance Image Upload' || q.question == 'Secondary Insurance Name' 
    //    || q.question == 'Secondary Insurance Number' || q.question == 'Secondary Insurance Group Name' 
    //    || q.question == 'Secondary Insurance Image upload'){ return true;}
    //    else{ return false;}
    },

    //QuestionActive
    DemoActiveChange(questId, isRequired) {
      this.intDummyComm();
      var objt = {
        questId: questId,
        IsRequired: isRequired,
        dc: this.dummyComm,
      };
      const url = this.SERVER + "/VNSPRAAPI/Reasons/PostQuestionaire";
      this.axiosGetProfileData1(url, objt);
    },
    async axiosGetProfileData1(Url, objt) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: Url,
        data: objt,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          const result = res.data;
          if (result.status) {
            console.log("ok");
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          loader.hide();
          this.ResetLogoutTime();
        });
    },
    addNewClick() {
      this.rating.forEach((e) => {
        e.head = "";
      });
      this.checkOpt = [{ questOption: "" }];
      this.quest = {
        question: "",
        answer: "",
        questionInputTypeId: 0,
      };
      $("#demoModal").modal("show");
    },

    //Timer
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    handleRole() {
      this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
      if (this.EmployeeRolesStr.length > 0) {
        if (this.myTitle == "Demo") {
          this.val = this.EmployeeRolesStr.filter((i) => i.name == "Demo");
          if (this.val[0].canUpdate == 0) {
            this.demo.updButton = 0;
          }
          if (this.val[0].canDelete == 0) {
            this.demo.delButton = 0;
          }
          if (this.val[0].canCreate == 0) {
            $("button[name=aQDemo]").hide();
          }
        } else {
          this.val = this.EmployeeRolesStr.filter(
            (i) => i.name == "Questionnaire"
          );
          if (this.val[0].canUpdate == 0) {
            this.demo.updButton = 0;
          }
          if (this.val[0].canDelete == 0) {
            this.demo.delButton = 0;
          }
          if (this.val[0].canCreate == 0) {
            $("button[name=aQDemo]").hide();
          }
        }
      }
    },

    activeClick(id, index) {
      const a = this.quesList[index].isActive ? "0" : "1";
      this.intDummyComm();
      this.dummyComm.extras = id + this.UKEY + a + this.UKEY;
      const myurl = this.SERVER + "/VNSPRAAPI/Reasons/ACTQUEST";
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      axios({
        method: "post",
        url: myurl,
        data: this.dummyComm,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          this.dummyComm = res.data;
          if (this.dummyComm.auditFlag > 0) {
            createToast("Information Added", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            this.quesList[index].isActive = !this.quesList[index].isActive;
          } else {
            createToast(this.dummyComm.auditFlagVal, {
              type: "danger",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => {
          loader.hide();
          this.ResetLogoutTime();
        });
    },

    archiveClick(id, index) {
      const a = this.quesList[index].isActive ? "0" : "1";
      this.intDummyComm();
      this.dummyComm.extras = id + this.UKEY + a + this.UKEY;
      const myurl = this.SERVER + "/VNSPRAAPI/Reasons/ARCQUEST";
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      axios({
        method: "post",
        url: myurl,
        data: this.dummyComm,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          this.dummyComm = res.data;
          if (this.dummyComm.auditFlag > 0) {
            createToast("Information Added", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            this.quesList[index].isActive = !this.quesList[index].isActive;
          } else {
            createToast(this.dummyComm.auditFlagVal, {
              type: "danger",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => {
          loader.hide();
          this.ResetLogoutTime();
        });
    },

    updateClick() {
      if (this.quest.questionInputTypeId == 1) {
        if (this.quest.question == "") {
          this.ShowWarning("TextBox is require");
          event.preventDefault();
          return;
        }
      } else if (this.quest.questionInputTypeId == 2) {
        for (i = 0; i < this.checkOpt.length; i++) {
          if (this.checkOpt[i].questOption == "") {
            this.ShowWarning("All Inputs required");
            event.preventDefault();
            return;
          }
        }
        if (this.quest.question == "") {
          this.ShowWarning("All Inputs required");
          event.preventDefault();
          return;
        }
      } else if (this.quest.questionInputTypeId == 3) {
        for (var i = 0; i < this.checkOpt.length; i++) {
          if (this.checkOpt[i].questOption == "") {
            this.ShowWarning("All Inputs required");
            event.preventDefault();
            return;
          }
        }
        if (this.quest.question == "") {
          this.ShowWarning("All Inputs required");
          event.preventDefault();
          return;
        }
      } else if (this.quest.questionInputTypeId == 4) {
        for (i = 0; i < this.checkOpt.length; i++) {
          if (this.checkOpt[i].questOption == "") {
            this.ShowWarning("All Inputs required");
            event.preventDefault();
            return;
          }
        }
        if (this.quest.question == "") {
          this.ShowWarning("All Inputs required");
          event.preventDefault();
          return;
        }
      } else if (this.quest.questionInputTypeId == 7) {
        if (this.quest.question == "") {
          this.ShowWarning("Date Question is require");
          event.preventDefault();
          return;
        }
        // else if (document.getElementById("EditDate").value != "") {
        //   if (!this.isValidateDate(document.getElementById("EditDate").value)) {
        //     this.ShowWarning("Valid Date is required");
        //     event.preventDefault();
        //     return;
        //   }
        // }
      } else if (this.quest.questionInputTypeId == 6) {
        this.quest.answer = this.phoneDummy;
        if (this.quest.question == "") {
          this.ShowWarning("Number Question is require");
          event.preventDefault();
          return;
        }
        // else if (this.quest.answer != "") {
        //   if (this.quest.answer.length < 12) {
        //     this.ShowWarning("Phone Number must be of 10 length");
        //     event.preventDefault();
        //     return;
        //   }
        // }
      } else if (this.quest.questionInputTypeId == 5) {
        if (this.quest.question == "") {
          this.ShowWarning("Email TextBox is require");
          event.preventDefault();
          return;
        }
        // if (this.quest.answer != "") {
        //   if (!this.validEmail(this.quest.answer)) {
        //     event.preventDefault();
        //     this.Validity(this.e);
        //   }
        // }
      }

      // if (this.quest.questionInputTypeId == 7) {
      //   this.quest.answer = document.getElementById("EditDate").value;
      // }

      let passData = {
        question: this.quest.question,
        answer: this.quest.answer,
        questionInputTypeId: this.quest.questionInputTypeId,
        dc: this.dummyComm,
        //questSaveInput: this.quest,
        qo: this.checkOpt,
      };
      //$( "#Upd_btn" ).prop( "disabled", true );
      var elems = document.querySelectorAll('[id^="Upd_btn"]');
      for (i = 0; i < elems.length; i++) {
        elems[i].disabled = true;
      }
      event.preventDefault();
      this.intDummyComm();
      this.dummyComm.extras = this.quest.questId + this.UKEY;
      const myurl = this.SERVER + "/VNSPRAAPI/Reasons/UPDQUEST";
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      axios({
        method: "post",
        url: myurl,
        data: passData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          $("#RatingEdit").modal("hide");
          $("#TextBoxEdit").modal("hide");
          $("#CheckBoxEdit").modal("hide");
          $("#RadioEdit").modal("hide");
          $("#EmailEdit").modal("hide");
          $("#PhoneQ").modal("hide");
          $("#DOBQ").modal("hide");

          this.dummyComm = res.data;
         //debugger // eslint-disable-line no-debugger
          if (this.dummyComm.auditFlag > 0) {
            createToast("Information Updated", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            //this.$router.go(0);
            //alert(this.dummyComm.auditFlagVal);
            //this.$forceUpdate();
          } else {
            createToast(this.dummyComm.auditFlagVal, {
              type: "danger",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          }
          this.loadInit();
          var elems = document.querySelectorAll('[id^="Upd_btn"]'); //Disabel Multiple buttons with same Id
          for (i = 0; i < elems.length; i++) {
            elems[i].disabled = false;
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => {
          loader.hide();
          this.ResetLogoutTime();
        });
    },

    editButtonClick(id) {
      this.intDummyComm();
      this.dummyComm.extras = id + this.UKEY;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTSNGQUEST";
      this.axiosGetData(url, 3);
    },

    saveClick() {
      if (this.optionSelected == 1) {
        if (this.quest.question == "") {
          this.ShowWarning("TextBox is required");
          return;
        }
      } else if (this.optionSelected == 2) {
        for (i = 0; i < this.checkOpt.length; i++) {
          if (this.checkOpt[i].questOption == "") {
            this.ShowWarning("All Inputs required");
            event.preventDefault();
            return;
          }
        }
        if (this.quest.question == "") {
          this.ShowWarning("All Inputs required");
          event.preventDefault();
          return;
        }
      } else if (this.optionSelected == 3) {
        for (var i = 0; i < this.rating.length; i++) {
          if (this.rating[i].head == "") {
            this.ShowWarning("All Inputs required");
            return;
          }
        }
        if (this.quest.question == "") {
          this.ShowWarning("All Inputs required");
          return;
        }
      } else if (this.optionSelected == 4) {
        for (i = 0; i < this.checkOpt.length; i++) {
          if (this.checkOpt[i].questOption == "") {
            this.ShowWarning("All Inputs required");
            event.preventDefault();
            return;
          }
        }
        if (this.quest.question == "") {
          this.ShowWarning("All Inputs required");
          event.preventDefault();
          return;
        }
      } else if (this.optionSelected == 7) {
        if (this.quest.question == "") {
          this.ShowWarning("Date Question is require");
          return;
        }
      } else if (this.optionSelected == 6) {
        if (this.quest.question == "") {
          this.ShowWarning("Number Question is require");
          event.preventDefault();
          return;
        }
      } else if (this.optionSelected == 5) {
        if (this.quest.question == "") {
          this.ShowWarning("Email TextBox is require");
          return;
        }
      }

      if (this.optionSelected < 1) return;
      else {
        if (this.optionSelected == 3) {
          this.checkOpt = [];
          for (let i = 0; i < this.rating.length; i++) {
            this.checkOpt.push({ questOption: this.rating[i].head });
          }
        } else if (this.optionSelected == 7) {
          this.quest.answer = document.getElementById("NewDate").value;
        }
        this.intDummyComm();
        this.dummyComm.extras = this.myTitle + this.UKEY;

        this.quest.questionInputTypeId = this.optionSelected;

        $("#Demosave_btn").prop("disabled", true);
        let passData = {
          question: this.quest.question,
          answer: this.quest.answer,
          questionInputTypeId: this.quest.questionInputTypeId,

          dc: this.dummyComm,
          //questSaveInput: this.quest,
          qo: this.checkOpt,
        };

        //alert(passData.question + '      ' + this.quest.question);
        var loader = this.$loading.show({
          // Optional parameters
          color: "#03a9f3",
        });
        axios({
          method: "post",
          url: this.SERVER + "/VNSPRAAPI/Reasons/SVQUEST",
          data: passData,
           headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
        })
          .then((res) => {
            loader.hide();
            this.dummyComm = res.data;
            if (this.dummyComm.auditFlag > 0) {
              //alert(this.dummyComm.auditFlagVal);
              createToast("Information Added", {
                type: "success",
                showIcon: "true",
                transition: "slide",
                timeout: 1500,
              });
              $("#demoModal").modal("hide");
              this.loadInit();
            } else {
              createToast(this.dummyComm.auditFlagVal, {
                type: "danger",
                showIcon: "true",
                transition: "slide",
                timeout: 1500,
              });
            }
            $("#Demosave_btn").prop("disabled", false);
          })
          .catch(function (error) {
            if (error.response) {
              alert("-> " + error.response.data);
              alert("-> " + error.response.status);
              alert("-> " + error.response.headers);
            } else if (error.request) {
              alert("No response " + error.request);
            }
          })
          .finally(() => {
            loader.hide(); this.ResetLogoutTime();
          });
      }
    },

    checkboxDynamic(what, index) {
      if (what == "+") {
        // const aa = this.checkOpt[this.checkOpt.length - 1].questOption;
        this.checkOpt.push({ questOption: "" });
        // this.checkOpt[this.checkOpt.length - 1] = { questOption: aa };
        // this.checkOpt[this.checkOpt.length - 2] = { questOption: "" };
      } else {
        this.checkOpt.splice(index, 1);
      }
    },
    showQuestionTypeTextbox() {
      if (this.quest.question) {
        Swal.fire({
          icon: "danger",
          text: "Are you sure you want to move into another Tab, If yes than your data will be lost",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
        }).then((e) => {
          if (e.isConfirmed) {
            this.quest = {
              question: "",
              answer: "",
              questionInputTypeId: 0,
            };
            document.getElementById("question_type_textbox").value == "";
            this.optionSelected = 1;
            $(".question_type").removeClass("active");
            $("#question_type_textbox").addClass("active");
            $(".myActive").removeClass("active");
            $("#btn-active").addClass("active");
          }
        });
      } else {
        this.quest = {
          question: "",
          answer: "",
          questionInputTypeId: 0,
        };
        document.getElementById("question_type_textbox").value == "";
        this.optionSelected = 1;
        $(".question_type").removeClass("active");
        $("#question_type_textbox").addClass("active");
        $(".myActive").removeClass("active");
        $("#btn-active").addClass("active");
      }
    },
    showQuestionTypeCheckbox() {
      if (this.quest.question) {
        Swal.fire({
          icon: "danger",
          text: "Are you sure you want to move into another Tab, If yes than your data will be lost",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
        }).then((e) => {
          if (e.isConfirmed) {
            this.quest = {
              question: "",
              answer: "",
              questionInputTypeId: 0,
            };
            document.getElementById("question_type_checkbox").value == "";
            this.checkOpt = [{ questOption: "" }];
            this.optionSelected = 2;
            $(".question_type").removeClass("active");
            $("#question_type_checkbox").addClass("active");
            $(".myActive").removeClass("active");
            $("#btn_active").addClass("active");
          }
        });
      } else {
        this.quest = {
          question: "",
          answer: "",
          questionInputTypeId: 0,
        };
        document.getElementById("question_type_checkbox").value == "";
        this.checkOpt = [{ questOption: "" }];
        this.optionSelected = 2;
        $(".question_type").removeClass("active");
        $("#question_type_checkbox").addClass("active");
        $(".myActive").removeClass("active");
        $("#btn_active").addClass("active");
      }
    },

    showQuestionTypeRating() {
      if (this.quest.question) {
        Swal.fire({
          icon: "danger",
          text: "Are you sure you want to move into another Tab, If yes than your data will be lost",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
        }).then((e) => {
          if (e.isConfirmed) {
            this.quest = {
              question: "",
              answer: "",
              questionInputTypeId: 0,
            };
            document.getElementById("question_type_rating").value == "";
            this.optionSelected = 3;
            $(".question_type").removeClass("active");
            $("#question_type_rating").addClass("active");
            $(".myActive").removeClass("active");
            $("#active-btn").addClass("active");
          }
        });
      } else {
        this.quest = {
          question: "",
          answer: "",
          questionInputTypeId: 0,
        };
        document.getElementById("question_type_rating").value == "";
        this.optionSelected = 3;
        $(".question_type").removeClass("active");
        $("#question_type_rating").addClass("active");
        $(".myActive").removeClass("active");
        $("#active-btn").addClass("active");
      }
    },

    showQuestionTypeRadio() {
      if (this.quest.question) {
        Swal.fire({
          icon: "danger",
          text: "Are you sure you want to move into another Tab, If yes than your data will be lost",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
        }).then((e) => {
          if (e.isConfirmed) {
            this.quest = {
              question: "",
              answer: "",
              questionInputTypeId: 0,
            };
            document.getElementById("NewDate").value == "";
            this.checkOpt = [{ questOption: "" }];
            //this.optionSelected = 4;
            $(".question_type").removeClass("active");
            $("#question_type_radio").addClass("active");
            $(".myActive").removeClass("active");
            $("#active_btn").addClass("active");
          }
        });
      } else {
        this.quest = {
          question: "",
          answer: "",
          questionInputTypeId: 0,
        };
        document.getElementById("NewDate").value == "";
        this.optionSelected = 4;
        this.checkOpt = [{ questOption: "" }];
        $(".question_type").removeClass("active");
        $("#question_type_radio").addClass("active");
        $(".myActive").removeClass("active");
        $("#active_btn").addClass("active");
      }
    },

    showQuestionTypeEmail() {
      if (this.quest.question) {
        Swal.fire({
          icon: "danger",
          text: "Are you sure you want to move into another Tab, If yes than your data will be lost",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
        }).then((e) => {
          if (e.isConfirmed) {
            this.quest = {
              question: "",
              answer: "",
              questionInputTypeId: 0,
            };
            document.getElementById("question_type_email").value == "";
            this.optionSelected = 5;
            $(".question_type").removeClass("active");
            $("#question_type_email").addClass("active");
            $(".myActive").removeClass("active");
            $("#active-bt").addClass("active");
          }
        });
      } else {
        this.quest = {
          question: "",
          answer: "",
          questionInputTypeId: 0,
        };
        document.getElementById("question_type_email").value == "";
        this.optionSelected = 5;
        $(".question_type").removeClass("active");
        $("#question_type_email").addClass("active");
        $(".myActive").removeClass("active");
        $("#active-bt").addClass("active");
      }
    },

    showQuestionTypePhone() {
      if (this.quest.question) {
        Swal.fire({
          icon: "danger",
          text: "Are you sure you want to move into another Tab, If yes than your data will be lost",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
        }).then((e) => {
          if (e.isConfirmed) {
            this.quest = {
              question: "",
              answer: "",
              questionInputTypeId: 0,
            };
            document.getElementById("question_type_phone").value == "";
            this.optionSelected = 6;
            $(".question_type").removeClass("active");
            $("#question_type_phone").addClass("active");
            $(".myActive").removeClass("active");
            $("#active-bn").addClass("active");
          }
        });
      } else {
        this.quest = {
          question: "",
          answer: "",
          questionInputTypeId: 0,
        };
        document.getElementById("question_type_phone").value == "";
        this.optionSelected = 6;
        $(".question_type").removeClass("active");
        $("#question_type_phone").addClass("active");
        $(".myActive").removeClass("active");
        $("#active-bn").addClass("active");
      }
    },

    showQuestionTypeDate() {
      if (this.quest.question) {
        Swal.fire({
          icon: "danger",
          text: "Are you sure you want to move into another Tab, If yes than your data will be lost",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
        }).then((e) => {
          if (e.isConfirmed) {
            this.quest = {
              question: "",
              answer: "",
              questionInputTypeId: 0,
            };
            document.getElementById("question_type_date").value == "";
            this.optionSelected = 7;
            $(".question_type").removeClass("active");
            $("#question_type_date").addClass("active");
            $(".myActive").removeClass("active");
            $("#active-n").addClass("active");
          }
        });
      } else {
        this.quest = {
          question: "",
          answer: "",
          questionInputTypeId: 0,
        };
        document.getElementById("question_type_date").value == "";
        this.optionSelected = 7;
        $(".question_type").removeClass("active");
        $("#question_type_date").addClass("active");
        $(".myActive").removeClass("active");
        $("#active-n").addClass("active");
      }
    },

    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },
     async SearchDataTable()
    {
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTQLST_1";
      this.axiosGetData(url, 1);
      this.ResetLogoutTime();
    },
    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = this.myTitle + this.UKEY;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTQLST_1";

      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what) {
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = this.filter;
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      
      await axios({
        method: "post",
        url: myUrl,
        data: this.dummyComm,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          // if everything goes well -- we will get data
          this.lastErrorCode = 1;
          if (what === 1) {
            //$("#table001").DataTable().destroy();
            this.totalPages = res.data.dc.totalPages;
            this.pageSize = res.data.dc.pageSize;
            this.totalRows = res.data.dc.totalRow;
            this.pageNumber = res.data.dc.pageNumber;
            this.quesList = res.data.lbq;
            //alert(99999);
          } else if (what == 2) {
            this.dummyComm = res.data;
            if (this.dummyComm < 0) alert(this.dummyComm.auditFlagVal);
          } else if (what === 3) {
            if (res.data.dc.auditFlag > 0) {
              this.quest = res.data.qst;
              this.phoneDummy = this.quest.answer;
              this.checkOpt = res.data.options;
              this.dummyComm = res.data.dc;
              if (this.checkOpt.length == 0)
                this.checkOpt = [{ questOption: "" }];
              //alert(res.data.qst.questName);
              if (this.quest.questionInputTypeId == 1)
                $("#TextBoxEdit").modal("show");
              else if (this.quest.questionInputTypeId == 2)
                $("#CheckBoxEdit").modal("show");
              else if (this.quest.questionInputTypeId == 3) {
                for (let i = 0; i < this.rating.length; i++) {
                  this.rating[i].head = "";
                }
                for (let i = 0; i < this.checkOpt.length; i++)
                  this.rating[i].head = this.checkOpt[i].questOption;
                if (this.checkOpt.length < 5) {
                  const x = this.checkOpt.length;
                  for (let i = x; i < 5; i++)
                    this.checkOpt[i] = { questOption: "" };
                }
                $("#RatingEdit").modal("show");
              } else if (this.quest.questionInputTypeId == 4) {
                $("#RadioEdit").modal("show");
              } else if (this.quest.questionInputTypeId == 5) {
                $("#EmailEdit").modal("show");
              } else if (this.quest.questionInputTypeId == 6) {
                $("#PhoneQ").modal("show");
              } else if (this.quest.questionInputTypeId == 7) {
                $("#DOBQ").modal("show");
              }
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
          //this.lastErrorCode = this.lastErrorCode;
        });
    }, // axiosGetData
  //************************************************ Pagination fuctions */
    pageChange(obj) {
          //debugger;
          if (obj == "Next") {
            //debugger;
            if (this.pageNumber < this.totalPages) {
              this.pageNumber += 1;
            }
          } else if (obj == "Previous" && this.pageNumber != 1) {
            this.pageNumber -= 1;
          } else {
            this.pageNumber = obj;
          }
          const url =  this.SERVER+`/VNSPRAAPI/Reasons/GTQLST_1`;
          this.axiosGetData(url,1);
        },
        orderBy(column){
        //debugger;
        if(this.firstTime==true)
        {
          this.firstTime = false;
          return;
        }
        this.orderByCol = column;
        if(column==1)
        {
          if(this.asc_desc == "asc")
          {
            this.asc_desc ="desc";
            this.quesList =this.quesList.sort((a,b) => (a.isActive < b.isActive) ? 1 : ((b.isActive < a.isActive) ? -1 : 0));
          }
          else
          {
            this.asc_desc ="asc";
            this.quesList =this.practices.sort((a,b) => (a.isActive > b.isActive) ? 1 : ((b.isActive > a.isActive) ? -1 : 0))
          }
          
        }
        if(column==2)
        {
          if(this.asc_desc == "asc")
          {
            this.asc_desc ="desc";
            this.quesList =this.practices.sort((a,b) => (a.questId < b.questId) ? 1 : ((b.questId < a.questId) ? -1 : 0));
          }
          else
          {
            this.asc_desc ="asc";
            this.quesList =this.practices.sort((a,b) => (a.questId > b.questId) ? 1 : ((b.questId > a.questId) ? -1 : 0))
          }
        }
        if(column==3)
        {
          if(this.asc_desc == "asc")
          {
            this.asc_desc ="desc";
            this.quesList =this.practices.sort((a,b) => (a.questName < b.questName) ? 1 : ((b.questName < a.questName) ? -1 : 0));
          }
          else
          {
            this.asc_desc ="asc";
            this.quesList =this.practices.sort((a,b) => (a.questName > b.questName) ? 1 : ((b.questName > a.questName) ? -1 : 0));
          }
        }
        if(column==4)
        {
          if(this.asc_desc == "asc")
          {
            this.asc_desc ="desc";
            this.quesList =this.practices.sort((a,b) => (a.questionInputTypeName < b.questionInputTypeName) ? 1 : ((b.questionInputTypeName < a.questionInputTypeName) ? -1 : 0));
          }
          else
          {
            this.asc_desc ="asc";
            this.quesList =this.practices.sort((a,b) => (a.questionInputTypeName > b.questionInputTypeName) ? 1 : ((b.questionInputTypeName > a.questionInputTypeName) ? -1 : 0))
          }
        }
  },
  orderByRemeber(column){
    this.orderByCol = column;
    if(column==1)
    {
      if(this.asc_desc == "asc")
      {
        this.quesList =this.quesList.sort((a,b) => (a.isActive < b.isActive) ? 1 : ((b.isActive < a.isActive) ? -1 : 0));
      }
      else
      {
        this.quesList =this.practices.sort((a,b) => (a.isActive > b.isActive) ? 1 : ((b.isActive > a.isActive) ? -1 : 0))
      }
      
    }
    if(column==2)
    {
      if(this.asc_desc == "asc")
      {
         this.quesList =this.practices.sort((a,b) => (a.questId < b.questId) ? 1 : ((b.questId < a.questId) ? -1 : 0));
      }
      else
      {
        this.quesList =this.practices.sort((a,b) => (a.questId > b.questId) ? 1 : ((b.questId > a.questId) ? -1 : 0));
      }
    }
    if(column==3)
    {
      if(this.asc_desc == "asc")
      {
        this.quesList =this.practices.sort((a,b) => (a.questName < b.questName) ? 1 : ((b.questName < a.questName) ? -1 : 0));
      }
      else
      {
        this.quesList =this.practices.sort((a,b) => (a.questName > b.questName) ? 1 : ((b.questName > a.questName) ? -1 : 0));
      }
    }
    if(column==4)
    {
      if(this.asc_desc == "asc")
      {
         this.quesList =this.practices.sort((a,b) => (a.questionInputTypeName < b.questionInputTypeName) ? 1 : ((b.questionInputTypeName < a.questionInputTypeName) ? -1 : 0));
      }
      else
      {
         this.quesList =this.practices.sort((a,b) => (a.questionInputTypeName > b.questionInputTypeName) ? 1 : ((b.questionInputTypeName > a.questionInputTypeName) ? -1 : 0))
      }
    }
  },
    //************************************************ Pagination fuctions */
  }, // methods

  mounted() {
    if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    clearTimeout(this.loadObj);
    this.handleRole();
    this.loadInit();
  },
  unmounted() {
        clearTimeout(this.TimerObject);
      },

  watch: {
    quesList: function () {
      //   //alert(this.ques.length);
     console.log(this.quesList);
    }, // quesList
  }, // watch
};
</script>

<style scoped>
.float-textarea,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 1px solid rgb(235, 235, 235);
  /* / box-shadow: none; / */
  width: 98%;
}

.float-textarea:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  /* / box-shadow: none; / */
  width: 98%;
}

.float-class,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  /* / border-bottom: 2px solid rgb(240, 141, 11); / */
  border-bottom: 1px solid rgb(235, 235, 235);
  box-shadow: none;
}
.float-class:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  box-shadow: none;
}
#font1{
    font-weight: 600;
    font-size: 15px;
}
.activeColor{
  background-color:#fb9678;
  color: white;
}
.colorActive{
  color:#f95c2e
}
.disabledColor{
  color:gray;
  background: lightgrey;
}
.asc-desc-btn{
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    color: honeydew;
}
</style>
